import React, { useState, useEffect } from "react";
import TimeInput from "react-time-picker-input";


const TimePicker = ({ onChange = () => {}, value } ) => {
  const [time, setTime] = useState('00:00')

  useEffect(() => {
    if (typeof value?.getHours !== 'function') {
      return;
    }

    const hours = value.getHours().toString().padStart(2, "0");
    const minutes = value.getMinutes().toString().padStart(2, "0");

    let newValue = `${hours}:${minutes}`
    
    if (time !== newValue) {
      setTime(newValue)
    }
  }, [value])

  const changeTime = (val) => {
    if (val === time) {
      return;
    }

    const [hour, minute] = val.split(':');
    const date = new Date(value)
    date.setHours(hour, minute, 0)
    onChange?.(date);
  }

  return (
    <TimeInput value={time} onChange={changeTime}/>
  );
};

export default TimePicker;
